import type { ReactNode } from "react"

/**
 * One calm settings group: a small tracked label, an optional one-line
 * description, optional trailing actions, then the content. Sections rise
 * in one after another on first paint; the delay is the only motion.
 */
export function Section({
    label,
    description,
    actions,
    order = 0,
    children,
}: {
    label: string
    description?: ReactNode
    actions?: ReactNode
    order?: number
    children: ReactNode
}) {
    return (
        <section className="sharing-rise" style={{ animationDelay: `${order * 70}ms` }} aria-label={label}>
            <div className="flex items-end justify-between gap-4 max-[600px]:flex-col max-[600px]:items-start">
                <div className="min-w-0">
                    <h3 className="text-[11px] font-semibold uppercase tracking-[0.16em] text-muted">{label}</h3>
                    {description && <p className="mt-1 text-xs leading-5 text-muted">{description}</p>}
                </div>
                {actions && <div className="flex flex-none items-center gap-2 max-[600px]:w-full">{actions}</div>}
            </div>
            <div className="mt-3">{children}</div>
        </section>
    )
}
